(function() { window.GUID_e422a60e_fd84_4de9_b33c_afd41550eac6 = { getGuid: function() { return "e422a60e-fd84-4de9-b33c-afd41550eac6"; } }; })();
//http://localhost/bracket/index?bracketid=2778&eventid=200&personaid=u54410&walltype=BracketWall
//http://localhost/bracket/index?bracketid=75702&eventid=8005&personaid=u54410&walltype=BracketWall
var CS;
(function (CS) {
    var Controls;
    (function (Controls) {
        class DragZoom extends Controls.ControlBase {
            constructor() {
                super(...arguments);
                this.negativeOffsetCumulWhileDragging = 0;
                this.pullToRefreshDragCumul = 0;
                this.zoomFactor = null;
                this.lastScale = 3;
                this.offset = null;
                this.previousOffset = null;
                this.initialOffset = new CS.Point({ X: 0, Y: 0 });
                this.lastZoomCenter = new CS.Point({ X: 0, Y: 0 });
                this.lastDragPosition = new CS.Point({ X: 0, Y: 0 });
                this.initialZoom = 0.5;
                this.FRICTION_COEFF = 0.85;
                this.sum = function (a, b) {
                    return a + b;
                };
            }
            get ControlId() {
                return this.controlId;
            }
            get $Control() {
                return this.$control;
            }
            OnControlInstantiation(params) {
                this.controlId = params[0];
                this.$control = $("#" + params[0]); //contient le Id
                this.baseParam.dontRaiseLoadedEvent = true;
                let me = this;
                me.noPadding = me.$Control.data("nopadding") == "True";
                me.allowPullToRefresh = me.$Control.data("allowpulltorefresh") == "True";
                me.elementForZoomSize = me.$Control.data("elementforzoomsize");
                me.FingerTouches = false;
                me.$Control.disableSelection();
                me.discoverUI();
                me.bindEvents();
                //me.appendCrossToIndicateMiddleOfScreen();
            }
            OnDispose() {
                if (this.gestureDetector) {
                    this.gestureDetector.Dispose();
                    this.gestureDetector = null;
                }
                this.$ScrollablePart.off("touchstart.dragzoom");
                CS.DOM.$win.off("resize.dragzoom");
                this.$ScrollablePart
                    .off("mousewheel.dragzoom")
                    .off("scroll.dragzoom")
                    .off("mousedown.dragzoom");
                CS.DOM.$body
                    .off("mousemove.bracket")
                    .off("mouseup.bracket")
                    .off("dblclick.bracket")
                    .off("mouseleave.bracket");
                //this.$ControlsPanel.off('mousedown.dragzoom').off('touchmove.dragzoom');
                this.$SlidePanel.off("click.dragzoom").off("touchmove.dragzoom");
                this.$Control.remove();
            }
            OnBindEvents() {
                let me = this;
                me.innerContentSize = new CS.Size(me.$InnerContent.width(), me.$InnerContent.height());
                me.container.style.overflow = "hidden";
                me.container.style.position = "relative";
                me.el.style.webkitTransformOrigin = "0% 0%";
                //me.el.style.mozTransformOrigin = '0% 0%';
                //me.el.style.msTransformOrigin = '0% 0%';
                //me.el.style.oTransformOrigin = '0% 0%';
                me.el.style.transformOrigin = "0% 0%";
                me.el.style.position = "absolute";
                me.update(null);
                me.updateAspectRatio();
                me.computeInitialOffset();
                me.minZoom = Math.min(me.$ScrollablePart.height() /* - 200*/ / me.elForZoomSize.clientHeight, me.$ScrollablePart.width() /* - 100*/ / me.elForZoomSize.clientWidth);
                me.maxZoom = 1;
                //Set the zoom factor so it`s always the same size no matter whe number of opponents
                if (!me.zoomFactor) {
                    me.zoomFactor = me.sanitizeZoomFactor(me.initialZoom / me.getInitialZoomFactor());
                }
                else {
                    me.zoomFactor = me.sanitizeZoomFactor(me.zoomFactor);
                }
                if (!me.offset) {
                    me.resetOffset();
                    me.CenterUI();
                }
                else {
                    me.previousOffset = Object.assign({}, me.offset);
                    me.offset = me.sanitizeOffset(me.offset);
                }
                me.update(null);
                me.OnControlRendered();
                // CS.DOM.$body.offon("pullToRefreshLoaded.dragzoom", () => {
                //   PullToRefresh.Current.Desactivate();
                // });
            }
            discoverUI() {
                this.$Header = this.$Control.find(".drag-zoom-header");
                //this.$ControlsPanel = this.$Control.find('.drag-zoom-controls');
                this.$SlidePanel = this.$Control.find(".drag-zoom-context-panel");
                this.$InnerSlidePanel = this.$SlidePanel.find(".inner-slide-panel");
                this.$ContextMenu = this.$Control.find(".drag-zoom-context-menu");
                this.$ScrollablePart = this.$Control.find(".scrollable-part");
                this.$Inner = this.$ScrollablePart.find("> .inner");
                this.$InnerContent = this.$Inner.children();
                this.container = this.$ScrollablePart[0];
                this.el = this.$Inner[0];
                if (this.elementForZoomSize) {
                    let $element = this.$Control.find(this.elementForZoomSize);
                    this.elForZoomSize = $element[0];
                }
                else {
                    this.elForZoomSize = this.el;
                }
            }
            AppendUIToHeader(ui) {
                let me = this;
                //ui.remove().appendTo(me.$Header);
                ui.appendTo(me.$Header);
                me.positionScrollablePartAndControls();
            }
            ShowSlidePanel(content) {
                this.$InnerSlidePanel.html(content);
                this.$SlidePanel.slideDown(200);
            }
            ShowContextMenu(position, content) {
                this.$ContextMenu.html(content);
                this.$ContextMenu.css({
                    top: position.top - this.$Control.offset().top + "px",
                    left: position.left + "px",
                });
                this.$ContextMenu.slideDown(200);
            }
            HideSlidePanel() {
                this.$SlidePanel.hide();
            }
            HideContextMenu() {
                this.$ContextMenu.hide();
            }
            GetState() {
                var offsetX = 0;
                var offsetY = 0;
                if (this.offset) {
                    if (!isNaN(this.offset.X)) {
                        offsetX = this.offset.X;
                    }
                    if (!isNaN(this.offset.Y)) {
                        offsetY = this.offset.Y;
                    }
                }
                return {
                    ScrollLeft: offsetX,
                    ScrollTop: offsetY,
                    Scale: this.zoomFactor,
                };
            }
            positionScrollablePartAndControls() {
                this.$ScrollablePart.css({ top: this.$Header.height() });
            }
            onScrolled(jqEvent, arg) {
                this.Trigger(DragZoom.EventNames.Scrolled, {
                    jqueryEventObject: jqEvent,
                    data: arg,
                });
                this.AutoScroll = false;
            }
            PreserveViewOnResize() {
                // Keep the same zoom reference when the keyboard changes the viewport.
                // This also keeps the saved zoom independent of the keyboard height.
                this.preservedInitialZoomFactor = this.getInitialZoomFactor();
            }
            onResize(e) {
                let me = this;
                me.minZoom = Math.min(me.$ScrollablePart.height() /* - 200*/ / me.el.clientHeight, me.$ScrollablePart.width() /* - 100*/ / me.el.clientWidth);
                me.update(e);
                me.positionScrollablePartAndControls();
                me.onScrolled(e, {});
                //if (me.fitted) {
                //    me.FitContentToScreen();
                //}
            }
            bindEvents() {
                let me = this;
                me.gestureDetector = new DetectGestures(this.el, this);
                me.$SlidePanel
                    .offon("click.dragzoom", ".cs-btn-close", function () {
                    me.HideSlidePanel();
                })
                    .offon("touchmove.dragzoom", function (e) {
                    e.stopPropagation();
                });
            }
            CenterUI() {
                if (!this.offset) {
                    return;
                }
                let me = this;
                me.minZoom = Math.min(me.$ScrollablePart.height() /* - 200*/ / me.el.clientHeight, me.$ScrollablePart.width() /* - 100*/ / me.el.clientWidth);
                this.offset.X =
                    -(me.$ScrollablePart.width() -
                        me.el.clientWidth * me.getInitialZoomFactor()) / 2;
                this.offset.Y =
                    -(me.$ScrollablePart.height() -
                        me.el.clientHeight * me.getInitialZoomFactor()) / 2;
                this.offset = this.sanitizeOffset(this.offset);
            }
            ScaleUp() {
                this.AnimateScale(1.1, this.getCurrentZoomCenter(), true, () => {
                    CS.Controls.DragZoom.SaveDragZoomStateWithDelay();
                });
            }
            ScaleDown() {
                this.AnimateScale(0.9, this.getCurrentZoomCenter(), true, () => {
                    CS.Controls.DragZoom.SaveDragZoomStateWithDelay();
                });
            }
            AnimateScale(newScale, center, animate, callback) {
                let me = this;
                let scale = newScale * this.zoomFactor;
                this.lastScale = scale;
                center = {
                    X: (me.$ScrollablePart.width() - me.$ScrollablePart.offset().left) / 2,
                    Y: (me.$ScrollablePart.height() - me.$ScrollablePart.offset().top) / 2,
                };
                let startZoomFactor = scale;
                let zoomFactor = scale;
                if (animate) {
                    let updateProgress = function (progress) {
                        me.scaleTo(startZoomFactor + progress * (zoomFactor - startZoomFactor), center);
                    };
                    this.animate(200, updateProgress, this.swing, () => {
                        if (callback) {
                            callback();
                        }
                    });
                }
                else {
                    me.scale(zoomFactor, center);
                    me.update(null);
                    if (callback) {
                        callback();
                    }
                }
            }
            AnimateScrollTo(pos, animate, callback) {
                let me = this;
                let currentPos = this.offset;
                pos = me.sanitizeOffset(pos);
                if (animate) {
                    let updateProgress = function (progress) {
                        if (me.offset && pos && currentPos) {
                            me.offset.X += (pos.X - currentPos.X) * progress;
                            me.offset.Y += (pos.Y - currentPos.Y) * progress;
                        }
                    };
                    this.animate(300, updateProgress, this.swing, () => {
                        me.lastDragPosition = me.offset;
                        me.end();
                        if (callback) {
                            callback();
                        }
                    });
                }
                else {
                    me.offset = pos;
                    me.lastDragPosition = me.offset;
                    me.end();
                    if (callback) {
                        callback();
                    }
                }
            }
            ScaleAndScrollTo(newScale, pos, dontRaiseEvent = false) {
                this.zoomFactor = this.sanitizeZoomFactor(newScale);
                this.offset = this.sanitizeOffset(pos);
                this.lastDragPosition = this.offset;
                this.end(dontRaiseEvent);
                //if (!dontRaiseEvent) {
                //    this.Trigger<DragZoom.IScaledEventArgs>(DragZoom.EventNames.Scaled, { jqueryEventObject: null, data: { NewScale: this.CurrentScale, OldScale: oldScale } });
                //}
            }
            ScrollToTopLeft() {
                this.ScaleAndScrollTo(this.initialZoom / this.getInitialZoomFactor(), {
                    X: 0,
                    Y: 0,
                });
            }
            ScrollToTopCenter() {
                const Y = 0;
                const X = this.$InnerContent[0].clientWidth / 2;
                this.ScaleAndScrollTo(this.initialZoom / this.getInitialZoomFactor(), {
                    X,
                    Y,
                });
            }
            // public ScrollToTopMiddle() {
            //     const Y = 0;
            //     const X = (this.$InnerContent[0].clientWidth / 2);
            //     this.ScaleAndScrollTo(this.initialZoom / this.getInitialZoomFactor(), { X, Y });
            // }
            CenterElement(element, noAnimation, onlyHorizontally = false, callback) {
                let me = this;
                if (element == null || element.length == 0) {
                    return;
                }
                //Pour utiliser les bonnes coordones au startup
                requestAnimationFrame(() => {
                    let elementOffset = element.offset();
                    let scrollerOffset = me.$ScrollablePart.offset();
                    let left = 0;
                    let top = 0;
                    let zoom = me.getInitialZoomFactor() * me.zoomFactor;
                    if (me.offset) {
                        left = me.offset.X + elementOffset.left;
                        top = me.offset.Y + elementOffset.top;
                    }
                    let x = left -
                        (me.$ScrollablePart.width() / 2 +
                            scrollerOffset.left -
                            (element.outerWidth() * zoom) / 2);
                    let y = 0;
                    if (!onlyHorizontally) {
                        y =
                            top -
                                (me.$ScrollablePart.height() / 2 +
                                    scrollerOffset.top -
                                    (element.outerHeight() * zoom) / 2);
                    }
                    me.AnimateScrollTo({ X: x, Y: y }, true, callback);
                });
            }
            // public ScrollToMiddle() {
            //    let left = ((this.$InnerContent[0].clientWidth / 2));
            //    let top = ((this.$InnerContent[0].clientHeight / 2));
            //    this.ScrollTo(left, top, true);
            // }
            //public FitContentToScreen() {
            //    //this.Scale(newScale);
            //    //this.ScrollToMiddle();
            //    this.fitted = true;
            //    this.RemoveContentTransparency();
            //}
            RemoveContentTransparency() {
                if (this.$Inner.css("opacity") == "0") {
                    if (CS.CommonData.Current.BrowserHasAnimationBug) {
                        this.$Inner.css("opacity", 1);
                    }
                    else {
                        this.$Inner.animate({ opacity: 1 }, 250);
                    }
                }
            }
            getScale() {
                return this.lastScale;
            }
            /**
             * Event handler for 'dragstart'
             * @param event
             */
            handleDragStart(event, point) {
                this.stopAnimation();
                this.lastDragPosition = point;
                this.hasInteraction = true;
                //this.handleDrag(event, point);
                this.previous = point;
                this.velocity = { X: 0, Y: 0 };
            }
            /**
             * Event handler for 'drag'
             * @param event
             */
            handleDrag(event, point) {
                this.previous = this.lastDragPosition;
                this.drag(point, this.lastDragPosition);
                this.offset = this.sanitizeOffset(this.offset);
                if (this.offset) {
                    if (isNaN(this.offset.X)) {
                        // console.log("nan");
                    }
                }
                this.lastDragPosition = point;
                if (this.previous && point)
                    this.velocity = {
                        X: (this.previous.X - point.X) * this.zoomFactor,
                        Y: (this.previous.Y - point.Y) * this.zoomFactor,
                    };
            }
            handleDragEnd() {
                let me = this;
                //if (me.velocity && (Math.abs(this.velocity.X) > 10 || Math.abs(this.velocity.Y) > 10)) {
                //    me.inertiaStep();
                //} else {
                this.end();
                //}
            }
            inertiaStep() {
                let me = this;
                let renderFrame = function () {
                    if (me.velocity) {
                        if (me.lastDragPosition) {
                            me.lastDragPosition.X += me.velocity.X;
                            me.lastDragPosition.Y += me.velocity.Y;
                        }
                        me.addOffset(me.velocity);
                        me.velocity.X *= me.FRICTION_COEFF;
                        me.velocity.Y *= me.FRICTION_COEFF;
                    }
                    me.offset = me.sanitizeOffset(me.offset);
                    if (me.velocity &&
                        (Math.abs(me.velocity.X) > 1 || Math.abs(me.velocity.Y) > 1)) {
                        me.update(null);
                        requestAnimationFrame(renderFrame);
                    }
                    else {
                        me.end();
                    }
                };
                requestAnimationFrame(renderFrame);
            }
            /**
             * Event handler for 'zoomstart'
             * @param event
             */
            handleZoomStart() {
                this.stopAnimation();
                this.lastScale = 1;
                this.nthZoom = 0;
                this.lastZoomCenter = null;
                this.hasInteraction = true;
            }
            /**
             * Event handler for 'zoom'
             * @param event
             */
            handleZoom(event, newScale, center) {
                // a relative scale factor is used
                let scale = newScale / this.lastScale;
                this.lastScale = newScale;
                this.offset = this.sanitizeOffset(this.offset);
                // the first touch events are thrown away since they are not precise
                this.nthZoom += 1;
                if (this.nthZoom > 3) {
                    this.scale(scale, center);
                    this.drag(center, this.lastZoomCenter);
                }
                this.lastZoomCenter = center;
            }
            handleZoomEnd() {
                this.end();
            }
            /**
             * Max / min values for the offset
             * @param offset
             * @return {Object} the sanitized offset
             */
            sanitizeOffset(offset) {
                let elWidth = this.el.offsetWidth * this.getInitialZoomFactor() * this.zoomFactor;
                let elHeight = this.el.offsetHeight * this.getInitialZoomFactor() * this.zoomFactor;
                let maxX = elWidth - this.getContainerX() + 50, // + this.options.horizontalPadding,
                maxY = elHeight - this.getContainerY() + 150, // + this.options.verticalPadding,
                maxOffsetX = Math.max(maxX, 0), maxOffsetY = Math.max(maxY, 0), minOffsetX = Math.min(maxX, 0) - 50, // - this.options.horizontalPadding,
                minOffsetY = Math.min(maxY, 0) - 50; // - this.options.verticalPadding;
                if (offset) {
                    // if (isNaN(this.offset.X) || isNaN(minOffsetX) || isNaN(maxOffsetX)) {
                    //   // console.log("nan");
                    // }
                    if (offset) {
                        return {
                            X: Math.min(Math.max(offset.X, minOffsetX), maxOffsetX),
                            Y: Math.min(Math.max(offset.Y, minOffsetY), maxOffsetY),
                        };
                    }
                    else {
                        return {
                            X: Math.min(minOffsetX, maxOffsetX),
                            Y: Math.min(minOffsetY, maxOffsetY),
                        };
                    }
                }
            }
            sanitizeZoomFactor(zoomFactor) {
                if (!this.minZoom)
                    return zoomFactor;
                //let scaledZoom = zoomFactor / this.getInitialZoomFactor();
                let minZoom = this.minZoom / this.getInitialZoomFactor();
                let maxZoom = this.maxZoom / this.getInitialZoomFactor();
                return Math.min(maxZoom, Math.max(minZoom, zoomFactor)); // * this.getInitialZoomFactor();
            }
            /**
             * Scale to a specific zoom factor (not relative)
             * @param zoomFactor
             * @param center
             */
            scaleTo(zoomFactor, center) {
                this.scale(zoomFactor / this.zoomFactor, center);
            }
            /**
             * Scales the element from specified center
             * @param scale
             * @param center
             */
            scale(scale, center) {
                scale = this.scaleZoomFactor(scale);
                if (center && this.offset) {
                    this.addOffset({
                        X: (scale - 1) * (center.X + this.offset.X),
                        Y: (scale - 1) * (center.Y + this.offset.Y),
                    });
                }
            }
            /**
             * Scales the zoom factor relative to current state
             * @param scale
             * @return the actual scale (can differ because of max min zoom factor)
             */
            scaleZoomFactor(scale) {
                let originalZoomFactor = this.zoomFactor;
                let inititialZoom = this.getInitialZoomFactor();
                let scaleZoom = originalZoomFactor * inititialZoom;
                if ((scaleZoom > this.minZoom && scale < 1) ||
                    (scale > 1 && scaleZoom < this.maxZoom)) {
                    this.zoomFactor *= scale;
                }
                let newScale = this.zoomFactor / originalZoomFactor;
                return newScale;
            }
            isCloseTo(value, expected) {
                return value > expected - 0.01 && value < expected + 0.01;
            }
            /**
             * Determine if the image is in a draggable state
             *
             * When the image can be dragged, the drag event is acted upon and cancelled.
             * When not draggable, the drag event bubbles through this component.
             *
             * @return {Boolean}
             */
            canDrag() {
                return true; ///*this.options.draggableUnzoomed ||*/ !this.isCloseTo(this.zoomFactor, 1);
            }
            /**
             * Drags the element
             * @param center
             * @param lastCenter
             */
            drag(center, lastCenter) {
                if (lastCenter && center) {
                    //if (this.options.lockDragAxis) {
                    //    // lock scroll to position that was changed the most
                    //    if (Math.abs(center.x - lastCenter.x) > Math.abs(center.y - lastCenter.y)) {
                    //        this.addOffset({
                    //            x: -(center.x - lastCenter.x),
                    //            y: 0
                    //        });
                    //    }
                    //    else {
                    //        this.addOffset({
                    //            y: -(center.y - lastCenter.y),
                    //            x: 0
                    //        });
                    //    }
                    //}
                    //else {
                    if (isNaN(center.X) ||
                        isNaN(lastCenter.X) ||
                        isNaN(center.Y) ||
                        isNaN(lastCenter.Y)) {
                        // console.log("nan");
                        return;
                    }
                    this.addOffset({
                        Y: -(center.Y - lastCenter.Y),
                        X: -(center.X - lastCenter.X),
                    });
                    //}
                }
            }
            /**
             * Calculates the touch center of multiple touches
             * @param touches
             * @return {Object}
             */
            getTouchCenter(touches) {
                return this.getVectorAvg(touches);
            }
            /**
             * Calculates the average of multiple vectors (x, y values)
             */
            getVectorAvg(vectors) {
                return {
                    X: vectors
                        .map(function (v) {
                        return v.X;
                    })
                        .reduce(this.sum) / vectors.length,
                    Y: vectors
                        .map(function (v) {
                        return v.Y;
                    })
                        .reduce(this.sum) / vectors.length,
                };
            }
            /**
             * Adds an offset
             * @param offset the offset to add
             * @return return true when the offset change was accepted
             */
            addOffset(offset) {
                if (this.offset && !isNaN(this.offset.X) && !isNaN(this.offset.Y)) {
                    this.previousOffset = Object.assign({}, this.offset);
                    this.offset = {
                        X: this.offset.X + offset.X,
                        Y: this.offset.Y + offset.Y,
                    };
                }
                if (this.offset && isNaN(this.offset.X)) {
                    // console.log("nan");
                }
            }
            sanitize() {
                //if (this.zoomFactor < this.options.zoomOutFactor) {
                //    this.zoomOutAnimation();
                //} else if (this.isInsaneOffset(this.offset)) {
                //    this.sanitizeOffsetAnimation();
                //}
            }
            /**
             * Updates the container aspect ratio
             *
             * Any previous container height must be cleared before re-measuring the
             * parent height, since it depends implicitly on the height of any of its children
             */
            updateAspectRatio() {
                this.unsetContainerY();
                this.setContainerY(this.container.parentElement.offsetHeight);
            }
            /**
             * Calculates the initial zoom factor (for the element to fit into the container)
             * @return {number} the initial zoom factor
             */
            getInitialZoomFactor() {
                if (this.preservedInitialZoomFactor !== undefined) {
                    return this.preservedInitialZoomFactor;
                }
                let xZoomFactor = this.container.offsetWidth / this.elForZoomSize.offsetWidth;
                let yZoomFactor = this.container.offsetHeight / this.elForZoomSize.offsetHeight;
                return Math.min(xZoomFactor, yZoomFactor);
            }
            /**
             * Calculates the aspect ratio of the element
             * @return the aspect ratio
             */
            getAspectRatio() {
                return this.elForZoomSize.offsetWidth / this.elForZoomSize.offsetHeight;
            }
            /**
             * Calculates the virtual zoom center for the current offset and zoom factor
             * (used for reverse zoom)
             * @return {Object} the current zoom center
             */
            getCurrentZoomCenter() {
                let centerX = 0;
                let centerY = 0;
                if (this.offset && this.initialOffset) {
                    let offsetLeft = this.offset.X - this.initialOffset.X;
                    centerX =
                        -1 * this.offset.X -
                            offsetLeft / (this.zoomFactor == 1 ? 1 : 1 / this.zoomFactor - 1);
                    let offsetTop = this.offset.Y - this.initialOffset.Y;
                    centerY =
                        -1 * this.offset.Y -
                            offsetTop / (this.zoomFactor == 1 ? 1 : 1 / this.zoomFactor - 1);
                }
                return {
                    X: centerX,
                    Y: centerY,
                };
            }
            /**
             * Returns the touches of an event relative to the container offset
             * @param event
             * @return array touches
             */
            getTouches(event) {
                let rect = this.container.getBoundingClientRect();
                let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
                let scrollLeft = document.documentElement.scrollLeft || document.body.scrollLeft;
                let posTop = rect.top + scrollTop;
                let posLeft = rect.left + scrollLeft;
                return Array.prototype.slice
                    .call(event.touches)
                    .slice(0, 2)
                    .map(function (touch) {
                    return {
                        X: touch.pageX - posLeft,
                        Y: touch.pageY - posTop,
                    };
                });
            }
            /**
             * Compute the initial offset
             *
             * the element should be centered in the container upon initialization
             */
            computeInitialOffset() {
                this.initialOffset = {
                    X: -Math.abs(this.elForZoomSize.offsetWidth * this.getInitialZoomFactor() -
                        this.container.offsetWidth) / 2,
                    Y: -Math.abs(this.elForZoomSize.offsetHeight * this.getInitialZoomFactor() -
                        this.container.offsetHeight) / 2,
                };
            }
            /**
             * Reset current image offset to that of the initial offset
             */
            resetOffset() {
                if (this.initialOffset)
                    this.offset = { X: this.initialOffset.X, Y: this.initialOffset.Y };
            }
            setupOffsets() {
                //if (this.options.setOffsetsOnce && this._isOffsetsSet) {
                //    return;
                //}
                //this._isOffsetsSet = true;
                this.computeInitialOffset();
                this.resetOffset();
            }
            /**
             * Swing timing function for animations
             * @param p
             * @return {Number}
             */
            swing(p) {
                return -Math.cos(p * Math.PI) / 2 + 0.5;
            }
            getContainerX() {
                return this.container.offsetWidth;
            }
            getContainerY() {
                return this.container.offsetHeight;
            }
            setContainerY(y) {
                return (this.container.style.height = y + "px");
            }
            unsetContainerY() {
                this.container.style.height = null;
            }
            end(doNotTrigger = false) {
                this.hasInteraction = false;
                this.sanitize();
                this.update(null);
                if (!doNotTrigger) {
                    this.onScrolled(null, {});
                    CS.Controls.DragZoom.SaveDragZoomStateWithDelay();
                }
            }
            /**
             * Stops the animation
             */
            stopAnimation() {
                this.inAnimation = false;
            }
            /**
             * Animation loop
             * does not support simultaneous animations
             * @param duration
             * @param framefn
             * @param timefn
             * @param callback
             */
            animate(duration, framefn, timefn, callback) {
                let startTime = new Date().getTime();
                let me = this;
                let renderFrame = function () {
                    if (!me.inAnimation) {
                        return;
                    }
                    let frameTime = new Date().getTime() - startTime, progress = frameTime / duration;
                    if (frameTime >= duration) {
                        framefn(1);
                        if (callback) {
                            callback();
                        }
                        me.update(null);
                        me.stopAnimation();
                        me.update(null);
                    }
                    else {
                        if (timefn) {
                            progress = timefn(progress);
                        }
                        framefn(progress);
                        me.update(null);
                        requestAnimationFrame(renderFrame);
                    }
                };
                me.inAnimation = true;
                requestAnimationFrame(renderFrame);
            }
            /**
             * Updates the css values according to the current zoom factor and offset
             */
            update(e) {
                let me = this;
                if (e && e.type === "resize") {
                    this.updateAspectRatio();
                    if (this.preservedInitialZoomFactor !== undefined && this.offset) {
                        this.offset = this.sanitizeOffset(this.offset);
                    }
                    else {
                        this.setupOffsets();
                    }
                }
                if (e && e.type === "load") {
                    this.updateAspectRatio();
                    this.setupOffsets();
                }
                if (this.updatePlanned) {
                    return;
                }
                me.updatePlanned = true;
                //window.setTimeout((function () {
                requestAnimationFrame(function () {
                    me.updatePlanned = false;
                    let offsetX = 0;
                    let offsetY = 0;
                    let offsetXWithoutZoom = 0;
                    let offsetYWithoutZoom = 0;
                    let zoomFactor = me.getInitialZoomFactor() * me.zoomFactor;
                    if (me.offset) {
                        if (!isNaN(me.offset.X)) {
                            offsetXWithoutZoom = -me.offset.X;
                            offsetX = -me.offset.X / zoomFactor;
                        }
                        if (!isNaN(me.offset.Y)) {
                            offsetYWithoutZoom = me.offset.Y;
                            offsetY = -me.offset.Y / zoomFactor;
                        }
                    }
                    let transform3d = "scale3d(" +
                        zoomFactor +
                        ", " +
                        zoomFactor +
                        ",1) " +
                        "translate3d(" +
                        offsetX +
                        "px," +
                        offsetY +
                        "px,0px)", transform2d = "scale(" +
                        zoomFactor +
                        ", " +
                        zoomFactor +
                        ") " +
                        "translate(" +
                        offsetX +
                        "px," +
                        offsetY +
                        "px)";
                    //removeClone = (function () {
                    //    if (me.clone) {
                    //        me.clone.parentNode.removeChild(me.clone);
                    //        delete me.clone;
                    //    }
                    //})
                    // Hide some elements if zoomed too much
                    let zoom = (window.outerWidth - 10) / window.innerWidth;
                    me.$Inner.toggleClass("small-render", zoomFactor < 0.2 / zoom);
                    // Scale 3d and translate3d are faster (at least on ios)
                    // but they also reduce the quality.
                    // PinchZoom uses the 3d transformations during interactions
                    // after interactions it falls back to 2d transformations
                    //if (!this.options.use2d || this.hasInteraction || this.inAnimation) {
                    //me.is3d = true;
                    //removeClone();
                    //me.el.style.webkitTransform = transform3d;
                    //me.el.style.mozTransform = transform2d;
                    //me.el.style.msTransform = transform2d;
                    //me.el.style.oTransform = transform2d;
                    //me.el.style.transform = transform3d;
                    me.el.style.transform = transform3d;
                    //} else {
                    //    // When changing from 3d to 2d transform webkit has some glitches.
                    //    // To avoid this, a copy of the 3d transformed element is displayed in the
                    //    // foreground while the element is converted from 3d to 2d transform
                    //    if (this.is3d) {
                    //        this.clone = this.el.cloneNode(true);
                    //        this.clone.style.pointerEvents = 'none';
                    //        this.container.appendChild(this.clone);
                    //        window.setTimeout(removeClone, 200);
                    //    }
                    //    this.el.style.webkitTransform = transform2d;
                    //    this.el.style.mozTransform = transform2d;
                    //    this.el.style.msTransform = transform2d;
                    //    this.el.style.oTransform = transform2d;
                    //    this.el.style.transform = transform2d;
                    //    this.is3d = false;
                    //}
                    me.Trigger(DragZoom.EventNames.AfterUpdateTransform, {
                        jqueryEventObject: null,
                        data: {
                            Scale: zoomFactor,
                            ScaledOffsetX: offsetX,
                            ScaledOffsetY: offsetY,
                            OffsetX: offsetXWithoutZoom,
                            OffsetY: offsetYWithoutZoom,
                        },
                    });
                });
                //}), 0);
            }
            static SaveDragZoomStateWithDelay() {
                CS.Lag("save-dragzoom", 5000, function () {
                    if (CS.CommonData.Current.UserIsLoggedIn) {
                        let dragZoom = CS.DOM.$sectionMiddle.find('.drag-zoom');
                        if (dragZoom.length > 0) {
                            let dg = CS.Controls.GetInstance(CS.Controls.DragZoom, dragZoom);
                            let state = dg.GetState();
                            let userDataKey = dragZoom.data("userdatakey");
                            CS.Ajax.Post(CS.Url.CSUrl("SaveDragZoomState"), { dragZoomState: state, userDataKey: userDataKey }, function () {
                            });
                        }
                    }
                });
            }
            static ApplyLastScrollAndZoomState() {
                let dragZoom = CS.DOM.$sectionMiddle.find('.drag-zoom');
                let dragZoomState = dragZoom.data("state");
                console.log(dragZoomState);
                if (dragZoomState) {
                    let $dragZoom = CS.DOM.$sectionMiddle.find(".drag-zoom");
                    if ($dragZoom.length > 0 && dragZoomState.Scale) {
                        let dragZoom = Controls.GetInstance(Controls.DragZoom, $dragZoom);
                        dragZoom.ScaleAndScrollTo(dragZoomState.Scale, { X: dragZoomState.ScrollLeft, Y: dragZoomState.ScrollTop }, true);
                        return true;
                    }
                }
                return false;
            }
        }
        Controls.DragZoom = DragZoom;
        class DetectGestures {
            constructor(el, target) {
                this.interaction = null;
                this.fingers = 0;
                this.lastTouchStart = null;
                this.startTouches = null;
                this.el = null;
                this.target = null;
                this.isFirstMove = true;
                this.scrollablePart = null;
                this.nonPassiveEventOptions = { passive: false };
                this.getDistance = function (a, b) {
                    let x, y;
                    x = a.X - b.X;
                    y = a.Y - b.Y;
                    return Math.sqrt(x * x + y * y);
                };
                this.stopEventPropagation = function (event) {
                    event.stopPropagation();
                    event.preventDefault();
                };
                this.el = el;
                this.target = target;
                let me = this;
                this.scrollablePart = target.$ScrollablePart[0];
                this.touchStartHandler = this.handleTouchStart.bind(this);
                this.touchMoveHandler = this.handleTouchMove.bind(this);
                this.touchEndHandler = this.handleTouchEnd.bind(this);
                this.nativeGestureHandler = this.stopEventPropagation.bind(this);
                let mouseWheelEvents = "mousewheel.dragzoom";
                mouseWheelEvents += " DOMMouseScroll.dragzoom";
                mouseWheelEvents += " MozMousePixelScroll.dragzoom";
                CS.DOM.$win.offon("resize.dragzoom", (e) => {
                    target.onResize(e);
                });
                target.$ScrollablePart.offon(mouseWheelEvents, this.handleMouseWheelAction.bind(this));
                target.$ScrollablePart[0].addEventListener("touchstart", this.touchStartHandler, this.nonPassiveEventOptions);
                target.$ScrollablePart[0].addEventListener("touchmove", this.touchMoveHandler, this.nonPassiveEventOptions);
                target.$ScrollablePart[0].addEventListener("touchend", this.touchEndHandler, this.nonPassiveEventOptions);
                target.$ScrollablePart[0].addEventListener("gesturestart", this.nativeGestureHandler, this.nonPassiveEventOptions);
                target.$ScrollablePart[0].addEventListener("gesturechange", this.nativeGestureHandler, this.nonPassiveEventOptions);
                target.$ScrollablePart[0].addEventListener("gestureend", this.nativeGestureHandler, this.nonPassiveEventOptions);
                target.$ScrollablePart.offon("mousedown.dragzoom", this.handleMouseDown.bind(this));
                target.$ScrollablePart.offon("mousemove.dragzoom", this.handleMouseMove.bind(this));
                target.$ScrollablePart.offon("mouseup.dragzoom mouseleave.dragzoom dblclick.dragzoom", this.handleLeave.bind(this));
            }
            Dispose() {
                if (!this.scrollablePart) {
                    return;
                }
                this.scrollablePart.removeEventListener("touchstart", this.touchStartHandler, this.nonPassiveEventOptions);
                this.scrollablePart.removeEventListener("touchmove", this.touchMoveHandler, this.nonPassiveEventOptions);
                this.scrollablePart.removeEventListener("touchend", this.touchEndHandler, this.nonPassiveEventOptions);
                this.scrollablePart.removeEventListener("gesturestart", this.nativeGestureHandler, this.nonPassiveEventOptions);
                this.scrollablePart.removeEventListener("gesturechange", this.nativeGestureHandler, this.nonPassiveEventOptions);
                this.scrollablePart.removeEventListener("gestureend", this.nativeGestureHandler, this.nonPassiveEventOptions);
                this.scrollablePart = null;
            }
            onMove(gestureType, event) {
                try {
                    if (this.target.allowPullToRefresh) {
                        this.processPullToRefreshGesture(gestureType, event);
                    }
                }
                catch (error) {
                    console.error("Error in onMove", error);
                }
            }
            processPullToRefreshGesture(gestureType, event) {
                var _a, _b, _c, _d;
                try {
                    const offsetY = (_b = (_a = this.target.offset) === null || _a === void 0 ? void 0 : _a.Y) !== null && _b !== void 0 ? _b : 0;
                    const previousOffsetY = (_d = (_c = this.target.previousOffset) === null || _c === void 0 ? void 0 : _c.Y) !== null && _d !== void 0 ? _d : 0;
                    const diff = offsetY - previousOffsetY;
                    const isDraggingUp = diff > 0;
                    const diffString = `${diff > 0 ? "+" : ""}${diff}`;
                    CS.Helper.log("DragZoom", `From ${previousOffsetY} to ${offsetY} (${diffString})`);
                    if (isDraggingUp) {
                        this.target.pullToRefreshDragCumul = 0;
                        this.target.negativeOffsetCumulWhileDragging = 0;
                        return;
                    }
                    const isSameOffset = previousOffsetY == offsetY;
                    // When the top of the content is reached, the offset stops increasing.
                    // We want to start counting the negative offset from this point.
                    // So if the top is not reached, we reset the negative offset cumul.
                    if (!isSameOffset) {
                        this.target.pullToRefreshDragCumul = 0;
                        this.target.negativeOffsetCumulWhileDragging = 0;
                        return;
                    }
                    const previousOffsetIsNegative = previousOffsetY < 0;
                    const currentOffsetIsNegative = offsetY < 0;
                    if (!previousOffsetIsNegative || !currentOffsetIsNegative) {
                        this.target.pullToRefreshDragCumul = 0;
                        this.target.negativeOffsetCumulWhileDragging = 0;
                        return;
                    }
                    this.target.negativeOffsetCumulWhileDragging += 1;
                    const threshold = gestureType === "touch" ? 50 : 25;
                    if (this.target.negativeOffsetCumulWhileDragging < threshold) {
                        return;
                    }
                    const pullToRefreshInstance = CS.PullToRefresh.Current;
                    if (!pullToRefreshInstance) {
                        return;
                    }
                    if (CS.PullToRefresh.Current.Disabled) {
                        pullToRefreshInstance.Start();
                    }
                    CS.PullToRefresh.HandleMove(event);
                }
                catch (error) {
                    console.error("Error while processing pull to refresh gesture", error);
                }
            }
            handleLeave(e) {
                try {
                    if (this.fingers != 1 ||
                        (event.buttons != 0 && event.type == "mouseleave")) {
                        return;
                    }
                    this.interaction = null;
                    this.target.handleDragEnd();
                    this.isFirstMove = false;
                    this.fingers = 0;
                }
                catch (error) {
                    console.error("Error while handling mouse leave", error);
                }
            }
            handleMouseMove(e) {
                try {
                    if (e.buttons == 0) {
                        this.target.$ScrollablePart.trigger("mouseup.dragzoom");
                    }
                    if (this.fingers == 0) {
                        return;
                    }
                    let point = {
                        X: e.clientX,
                        Y: e.clientY,
                    };
                    if (this.isFirstMove) {
                        this.target.handleDragStart(e, point);
                        this.stopEventPropagation(e);
                    }
                    else {
                        this.target.handleDrag(e, point);
                        this.stopEventPropagation(e);
                        this.target.update(null);
                    }
                    this.isFirstMove = false;
                    this.onMove("mouse", e);
                }
                catch (error) {
                    console.error("Error while handling mouse move", error);
                }
            }
            handleMouseDown(e) {
                try {
                    this.isFirstMove = true;
                    this.fingers = 1;
                }
                catch (error) {
                    console.error("Error while handling mouse down", error);
                }
            }
            handleTouchEnd(e) {
                try {
                    this.fingers = e.touches.length;
                    this.updateInteraction(e);
                }
                catch (error) {
                    console.error("Error while handling touch end", error);
                }
            }
            handleTouchMove(e) {
                try {
                    this.stopEventPropagation(e);
                    if (this.isFirstMove) {
                        this.updateInteraction(e);
                        this.startTouches = this.targetTouches(e.touches);
                        this.isFirstMove = false;
                        return;
                    }
                    if (this.interaction === "zoom") {
                        if (this.startTouches.length == 2 && e.touches.length >= 2) {
                            let touchCenter = this.target.getTouchCenter(this.target.getTouches(e));
                            this.target.handleZoom(e, this.calculateScale(this.startTouches, this.targetTouches(e.touches)), touchCenter);
                        }
                    }
                    else if (this.interaction === "drag") {
                        let touch = this.target.getTouches(e)[0];
                        this.target.handleDrag(e, touch);
                    }
                    if (this.interaction) {
                        this.target.update(null);
                    }
                    this.isFirstMove = false;
                    this.onMove("touch", e);
                }
                catch (error) {
                    console.error("Error while handling touch move", error);
                }
            }
            handleTouchStart(e) {
                try {
                    console.log("touch start.....");
                    let newFingers = Math.min(e.touches.length, 2);
                    if (this.interaction == "zoom" &&
                        this.fingers == 2 &&
                        newFingers == 2) {
                        // console.log("skipping touchstart");
                        return;
                    }
                    this.isFirstMove = true;
                    this.fingers = newFingers;
                    //me.detectDoubleTap(event);
                }
                catch (error) {
                    console.error("Error while handling touch start", error);
                }
            }
            handleMouseWheelAction(e) {
                try {
                    this.stopEventPropagation(e);
                    let myEvent = e.originalEvent;
                    let scrollableOffset = this.target.$ScrollablePart.offset();
                    let pos = { X: myEvent.clientX, Y: myEvent.clientY };
                    if (scrollableOffset) {
                        pos = {
                            X: myEvent.clientX - scrollableOffset.left,
                            Y: myEvent.clientY - scrollableOffset.top,
                        };
                    }
                    let direction = myEvent.wheelDelta > 0 || myEvent.detail < 0 ? 1 : -1;
                    if (e.ctrlKey || e.shiftKey || e.altKey) {
                        this.target.handleZoomStart();
                        this.target.nthZoom = 4; //Don't worry about that
                        //target.getRelativeMousePosition(1, false);
                        //console.log((<any>myEvent).wheelDelta + " " + (<any>myEvent).deltaY);
                        let scale = Math.abs(myEvent.deltaY) < 50 ? 0.04 : 0.1; //Don't zoom as fast when pinching on touchpad
                        this.target.handleZoom(e, 1 + scale * direction, pos);
                        this.target.handleZoomEnd();
                    }
                    else {
                        let previous = { X: 150, Y: 150 - 30 * direction };
                        let current = { X: 150, Y: 150 };
                        this.target.handleDragStart(event, previous);
                        this.target.lastDragPosition = previous;
                        this.target.handleDrag(event, current);
                        this.target.handleDragEnd();
                    }
                }
                catch (error) {
                    console.error("Error while handling mouse wheel action", error);
                }
            }
            setInteraction(newInteraction, event) {
                if (this.interaction !== newInteraction) {
                    if (this.interaction && !newInteraction) {
                        switch (this.interaction) {
                            case "zoom":
                                this.target.handleZoomEnd();
                                break;
                            case "drag":
                                this.target.handleDragEnd();
                                break;
                        }
                    }
                    switch (newInteraction) {
                        case "zoom":
                            this.target.handleZoomStart();
                            break;
                        case "drag":
                            let touch = this.target.getTouches(event)[0];
                            this.target.handleDragStart(event, touch);
                            break;
                    }
                }
                this.interaction = newInteraction;
            }
            updateInteraction(event) {
                if (this.fingers === 2) {
                    this.setInteraction("zoom", null);
                }
                else if (this.fingers === 1 && this.target.canDrag()) {
                    this.setInteraction("drag", event);
                }
                else {
                    this.setInteraction(null, event);
                }
            }
            targetTouches(touches) {
                return Array.from(touches)
                    .slice(0, 2)
                    .map(function (touch) {
                    return {
                        X: touch.pageX,
                        Y: touch.pageY,
                    };
                });
            }
            calculateScale(startTouches, endTouches) {
                let startDistance = this.getDistance(startTouches[0], startTouches[1]), endDistance = this.getDistance(endTouches[0], endTouches[1]);
                return endDistance / startDistance;
            }
            detectDoubleTap(event) {
                let time = new Date().getTime();
                if (this.fingers > 1) {
                    this.lastTouchStart = null;
                }
                //if (time - this.lastTouchStart < 300) {
                //    this.cancelEvent(event);
                //    this.target.handleDoubleTap(event);
                //    switch (this.interaction) {
                //        case "zoom":
                //            this.target.handleZoomEnd(event);
                //            break;
                //        case 'drag':
                //            this.target.handleDragEnd(event);
                //            break;
                //    }
                //} else {
                //    this.target.isDoubleTap = false;
                //}
                if (this.fingers === 1) {
                    this.lastTouchStart = time;
                }
            }
        }
        (function (DragZoom) {
            class Events {
                static Scrolled(param) {
                    Controls.RegisterEvent(DragZoom, EventNames.Scrolled, param);
                }
                static Scaled(param) {
                    Controls.RegisterEvent(DragZoom, EventNames.Scaled, param);
                }
                static TouchStarted(param) {
                    Controls.RegisterEvent(DragZoom, EventNames.TouchStarted, param);
                }
                static TouchEnded(param) {
                    Controls.RegisterEvent(DragZoom, EventNames.TouchEnded, param);
                }
                static AfterUpdateTransform(param) {
                    Controls.RegisterEvent(DragZoom, EventNames.AfterUpdateTransform, param);
                }
            }
            DragZoom.Events = Events;
            class EventNames {
            }
            EventNames.Scrolled = "scrolled";
            EventNames.Scaled = "scaled";
            EventNames.TouchStarted = "touchstarted";
            EventNames.TouchEnded = "touchended";
            EventNames.AfterUpdateTransform = "afterupdatetransform";
            DragZoom.EventNames = EventNames;
        })(DragZoom = Controls.DragZoom || (Controls.DragZoom = {}));
    })(Controls = CS.Controls || (CS.Controls = {}));
})(CS || (CS = {}));

//# sourceMappingURL=drag-zoom.js.map
